import React from "react";

const BuildMiiRefetchModal = ({jobDescriptionStatus, onClick}) => {

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
       <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center lg:block lg:p-0">
          <div className="fixed inset-0 transition-opacity">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <span className="hidden lg:inline-block lg:align-middle lg:h-screen"></span>
          <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all lg:my-8 lg:align-middle lg:max-w-2xl lg:w-full">
            <div className="bg-white-700 px-4 py-3 lg:px-6 lg:flex lg:flex-col">
                <div className="flex flex-row  w-full justify-center">
                    <span className="font-bold text-[1.5rem] text-black-600 text-center">
                      {`We're Experiencing Technical Difficulties`}
                    </span>
                </div>
                <div className="flex flex-row  w-full justify-center mt-5">
                    <p className="text-[1rem] text-center">
                      Our apologies, but we're unable to process your request at the moment due to a server issue. This could be due
                      to heavy traffic or a temporary server error.
                    </p>
                </div>
                <div className="flex flex-row  w-full justify-center mt-5">
                    <p className="text-[1rem] text-center">
                      To continue, please click the <b>"Resend"</b> button to attempt to regenerate your Job Description.
                    </p>
                </div>
                <div className="flex flex-row  w-full justify-center p-5">
                    <button className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full" onClick={onClick}>
                    Resend
                    </button>
                </div>
            </div>
        </div>
      </div>
  </div>
  )
};

export default BuildMiiRefetchModal;
